export const redirectToPageUrl = (redirectTo: string, page) => {
  switch (redirectTo) {
    case 'AwardPage':
      return `/awards/${page?.slug}`;
    case 'EventPage':
      return `/events/${page?.slug}`;
    case 'NewsArticlePage':
      return `/news/${page?.slug}`;
    case 'CaseStudyPage':
      return `/work/${page?.slug}`;
    case 'InsightArticle':
      return `/insights/${page?.slug}`;
    default:
      return '';
  }
};
